define.alias("shared/components/shared/social-identity/info", "settings/components/shared/social-identity/info");